import { Link } from "react-router-dom";
import logo from "../assets/logo_2.png";
import Container from "./Container";
import { FaTwitter, FaFacebookF, FaLinkedinIn, FaYoutube } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-slate-950/80 text-white">
      <Container>
        <div className="grid gap-10 py-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4">
            <img src={logo} alt="Hunt Share Live" className="h-14 w-auto" />
            <p className="max-w-xs text-sm leading-7 text-slate-400">
              Connecting creators, viewers, and communities through polished live experiences.
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-slate-200">Company</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              {[
                { name: "About Us", path: "/about" },
                { name: "Contact Us", path: "/contact" },
                { name: "Terms and Conditions", path: "/terms" },
                { name: "Rules and regulations", path: "/rules" },
                { name: "Privacy Policy", path: "/policy" },
                { name: "Child Safety Standards", path: "/child-safety" },
                { name: "Delete Account", path: "/deleteAccount" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="transition hover:text-orange-300">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-slate-200">Services</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              {[
                { name: "Live Stream", path: "/services", id: "live-stream" },
                { name: "In Stream Games", path: "/services", id: "in-stream-games" },
                { name: "Chat Rooms", path: "/services", id: "chat-rooms" },
                { name: "Agency System", path: "/services", id: "agency-system" },
                { name: "Fast Withdrawals", path: "/services", id: "fast-withdrawals" },
              ].map((link) => (
                <li key={link.id}>
                  <Link to={link.path} className="transition hover:text-orange-300">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-slate-200">Follow</h3>
            <div className="flex gap-3">
              <a href="https://twitter.com" target="_blank" rel="noreferrer" className="rounded-full border border-white/10 bg-white/5 p-3 text-slate-300 transition hover:border-orange-400/50 hover:text-orange-300"><FaTwitter /></a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="rounded-full border border-white/10 bg-white/5 p-3 text-slate-300 transition hover:border-orange-400/50 hover:text-orange-300"><FaFacebookF /></a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="rounded-full border border-white/10 bg-white/5 p-3 text-slate-300 transition hover:border-orange-400/50 hover:text-orange-300"><FaLinkedinIn /></a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className="rounded-full border border-white/10 bg-white/5 p-3 text-slate-300 transition hover:border-orange-400/50 hover:text-orange-300"><FaYoutube /></a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 py-6 text-center text-sm text-slate-500">
          © {new Date().getFullYear()} Hunt Share Live. All rights reserved.
        </div>
      </Container>
    </footer>
  );
}
